import { useMemo, useState } from 'react'
import { Reassign } from '../../../../Reassign/ReassignPopup'
import { Typography } from '../../../../../components/Typography'
import { Button, BUTTON_TYPES } from '../../../../../components/Button'
import { useContractDetailsContext } from 'features/ContractDetails/Providers/ContractDetailsContextProvider'
import { UserListItem } from 'features/ContractDetails/ContractDetailsGeneral/ResponsibleUsers/UserList/UserListItem'
import { ReactComponent as Plus16 } from '../../../../../assets/svg/Plus16.svg'
import { ROLES } from '../../../../Permission'
import { BTN_TXT } from '../../../../../constants'
import './styles.scss'

type Props = {
  vendor?: boolean
}

const UserList = ({ vendor }: Props) => {
  const contractDetailsContext = useContractDetailsContext()

  const [isOpenReassign, setIsOpenReassign] = useState(false)

  const { details, vendorCanSeeAddTeamMemberButton, isCommons } =
    contractDetailsContext.state

  const { getContractDetailsAsync } = contractDetailsContext.actions

  const responsibleUsers = useMemo(() => {
    if (vendor) {
      const vcs = details?.vendor_responsibles?.find(
        (i) => i.role === ROLES.VENDOR_CONTRACT_STEWARD
      )
      if (vcs) {
        const vendorResp =
          details?.vendor_responsibles.filter(
            (i) => i.role !== ROLES.VENDOR_CONTRACT_STEWARD
          ) ?? []
        return [vcs, ...vendorResp]
      } else {
        return [...(details?.vendor_responsibles ?? [])]
      }
    } else {
      return [details.creator]
    }
  }, [details.creator, details?.vendor_responsibles, vendor])

  if (vendor && !details?.vendor_responsibles.length) {
    return vendorCanSeeAddTeamMemberButton ? (
      <>
        <Button
          icon={<Plus16 />}
          type={BUTTON_TYPES.DEFAULT}
          onClick={() => setIsOpenReassign(true)}
          upperCase
        >
          {BTN_TXT.ADD_TEAM_MEMBER}
        </Button>
        <Reassign
          isRFP={false}
          isReassignPopupOpen={isOpenReassign}
          setIsReassignPopupOpen={setIsOpenReassign}
          ownerRole={ROLES.VENDOR_CONTRACT_STEWARD}
          ownerName={''}
          uuid={details?.uuid}
          isCommons={isCommons}
          update={getContractDetailsAsync}
          isAddNew
        />
      </>
    ) : (
      <div className="rfp-details-responsible__users-empty-state flex justify-center align-center full-width">
        <Typography.Headline6>Not yet assigned</Typography.Headline6>
      </div>
    )
  }

  return (
    <div className="rfp-details-responsible__user-list gap-24">
      {responsibleUsers.map((user) => (
        <UserListItem
          key={user.uuid}
          user={user}
          isOpenReassign={isOpenReassign}
          setIsOpenReassign={setIsOpenReassign}
        />
      ))}
    </div>
  )
}

export default UserList
